import className from 'classnames/bind';
import { Button, Container } from '@components';

import styles from './SectionFooter.module.scss';
import { getLinkData } from '@/core/utils';
const cx = className.bind(styles);

interface SectionFooterProps {
  text?: string;
  ctas?: {
    linkType?: string[];
    label?: string;
    externalLink?: string;
    page?: {
      node?: {
        uri?: string;
      };
    };
  }[];
}

export default function SectionFooter(props: SectionFooterProps) {
  const { text, ctas } = props;
  return (
    <div className={cx(["section-footer"])}>
      { text && <div className={cx("footer-text", "text-l")} dangerouslySetInnerHTML={{ __html: text }} /> }
      {ctas?.length && (
        <div className={cx("footer-ctas")}>
          {ctas.map((cta, index) => {
            const ctaData = getLinkData(cta);
            return (
              <Button
                key={index}
                {...ctaData}
                noIcon={true}
                className={cx("footer-cta", "button-secondary")}
              />
            );
          })}
        </div>
      )}
    </div>
  )
}